<button
  (click)="markAllBelongingNotificationsAsRead()"
  [attr.title]="text.mark_as_read"
  [ngClass]="buttonClasses"
  class="button">

  <op-icon icon-classes="button--icon icon-mark-read"></op-icon>
</button>
